import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";

export default function ClosedEventDialog({ event, open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="closed-event-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-slate-800">
            <Lock className="h-5 w-5 text-slate-500" /> Inscriptions clôturées
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {event?.title && <p className="text-sm font-semibold text-slate-700">{event.title}</p>}
          <p className="text-sm text-slate-600 leading-relaxed">
            Cet événement est désormais complet. L'inscription est clôturée. Merci de votre intérêt.
          </p>
          <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">CETF Association.</p>
          <Button className="w-full bg-slate-600 hover:bg-slate-700" onClick={() => onOpenChange(false)} data-testid="closed-event-ok-btn">
            J'ai compris
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
